import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import "../../../App.css";
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

const CategoryCard = ({
  cardImage,
  cardTitle,
  categoryClick,
  cardActiveImage,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };
  return (
    // <div
    //   className="home-category-card"
    //   style={{ border: "1px solid #0A64BC4D" }}
    //   onClick={() => categoryClick({ title: cardTitle, img: cardImage })}
    // >
    //   <img src={cardImage} style={{ height: "150px", width: "150px" }} />
    //   <Typography variant="subtitle1">{cardTitle}</Typography>
    // </div>
    // <Button variant="outlined" startIcon={<cardImage />} className="home-category-card2" onClick={() => categoryClick({ title: cardTitle, img: cardImage })} >
    <div
      style={{
        width: "243px",
        height: "301px",
        backgroundImage: isHovering
          ? `linear-gradient(360deg, #0A64BC 9.8%, rgba(217, 217, 217, 0) 54.15%),url(${cardImage})`
          : `url(${cardImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        cursor: "pointer",
        marginRight: "20px",
        marginBottom: "24px",
      }}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOut}
    >
      {/* <img src={cardImage} style={{ height: "50px", width: "50px" }} /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
          height: "95%",
        }}
      >
        <Typography
          variant="subtitle1"
          className="ml-4 button-text CategoryTitleText"
        >
          {cardTitle}
        </Typography>
        {isHovering ? (
          <Stack
            direction="row"
            spacing={2}
            className="ml-4"
            style={{ paddingLeft: "15px" }}
          >
            <Link to="/create-request" state={{ requestParam: cardTitle }}>
              <Typography
                style={{ color: "white", borderBottom: "1px solid #FF6D1C" }}
              >
                Post a Job
              </Typography>
            </Link>
            <Link to="/FindExperts" state={{ title: cardTitle }}>
              <Typography
                style={{ color: "white", borderBottom: "1px solid #FF6D1C" }}
              >
                Find Experts
              </Typography>
            </Link>
          </Stack>
        ) : null}
      </div>
    </div>
    // </Button>
  );
};

export default CategoryCard;
